// extracted by mini-css-extract-plugin
export default {"customerInfo":"CustomerInfo_customerInfo__r4hUf","flexRightContainer":"CustomerInfo_flexRightContainer__MoHHu"};